import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { strings } from '../../resources/strings';

export class TicketInfo extends Component {
    render() {
        return (
            <Container fluid className="mb-5 tariff">
                <Row className="mt-5" style={{ backgroundColor: '#e9ecef' }}>
                    <p className="ticket-info-title" dangerouslySetInnerHTML={{ __html: strings.ticketInfoTitle }} />

                    <a href="docs/Tarifas_AVE MOBILIDADE.pdf" target="_blank" rel="noopener noreferrer" style={{ fontSize: '0.8rem' }}>
                       <p dangerouslySetInnerHTML={{ __html: strings.ticketInfoTitleDownload }} />
                    </a>
                </Row>
                <Row style={{ marginTop: "2rem" }}>
                    <p className="ticket-info-attention" dangerouslySetInnerHTML={{ __html: strings.ticketInfoAttention }} />

                    <a href="docs/Apoio mobilidade_DIGITAL.pdf" target="_blank" rel="noopener noreferrer" style={{ fontSize: '0.8rem' }}>
                        <p dangerouslySetInnerHTML={{ __html: strings.ticketInfoAttentionDownload }} />
                    </a>
                </Row>
                <Row>
                    <Col md={6}>
                        <Row className="mt-5">
                            <h5 className="purple" dangerouslySetInnerHTML={{ __html: strings.ticketInfoOnBoardTitle }} />
                            <ul>
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoOnBoardL1 }} />
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoOnBoardL2 }} />
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoOnBoardL3 }} />
                            </ul>
                        </Row>
                        <Row className="mt-5">
                            <h5 className="green" dangerouslySetInnerHTML={{ __html: strings.ticketInfoSimpleTitle }} />
                            <ul>
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoSimpleL1 }} />
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoSimpleL2 }} />
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoSimpleL3 }} />
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoSimpleL4 }} />
                            </ul>
                        </Row>
                        <Row className="mt-5">
                            <h5 className="red" dangerouslySetInnerHTML={{ __html: strings.ticketInfoPrePurchaseTitle }} />
                            <ul>
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoPrePurchaseL1 }} />
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoPrePurchaseL2 }} />
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoPrePurchaseL3 }} />
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoPrePurchaseL4 }} />
                            </ul>
                        </Row>
                        <Row className="mt-5">
                            <h5 className="darkgreen" dangerouslySetInnerHTML={{ __html: strings.ticketInfoMonthlyPassTitle }} />
                            <ul>
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoMonthyPassL1 }} />
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoMonthyPassL2 }} />
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoMonthyPassL3 }} />
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoMonthyPassL4 }} />
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoMonthyPassL5 }} />
                                <br />
                                <li className="no-bullets">
                                    <span>
                                        <span dangerouslySetInnerHTML={{ __html: strings.ticketInfoMonthyPassL6 }} />
                                        <a
                                            href="docs/Apoio mobilidade_DIGITAL.pdf"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: 'blue', marginLeft: '4px' }}
                                            dangerouslySetInnerHTML={{ __html: strings.ticketInfoMonthyPassL7 }}
                                        />
                                    </span>
                                </li>
                            </ul>
                        </Row>
                    </Col>
                    <Col md={6}>
                        <Row className="mt-5">
                            <h5 className="yellow" dangerouslySetInnerHTML={{ __html: strings.ticketInfoSeniorPassTitle }} />
                            <ul>
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoSeniorPassL1 }} />
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoSeniorPassL2 }} />
                            </ul>
                        </Row>
                        <Row className="mt-5">
                            <h5 className="blue" dangerouslySetInnerHTML={{ __html: strings.ticketInfoYoungPassTitle }} />
                            <ul>
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoYoungPassL1 }} />
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoYoungPassL2 }} />
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoYoungPassL3 }} />
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoYoungPassL4 }} />
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoYoungPassL5 }} />
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoYoungPassL6 }} />
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoYoungPassL7 }} />
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoYoungPassL8 }} />
                            </ul>
                        </Row>
                        <Row className="mt-5">
                            <h5 className="darkgray" dangerouslySetInnerHTML={{ __html: strings.ticketInfoPPMCPassTitle }} />
                            <h5 className="darkgray" dangerouslySetInnerHTML={{ __html: strings.ticketInfoPPMCPassL1 }} />
                            <ul>
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoPPMCPassL2 }} />
                            </ul>
                            <h5 className="darkgray" dangerouslySetInnerHTML={{ __html: strings.ticketInfoPPMCPassL3 }} />
                            <ul>
                                <li dangerouslySetInnerHTML={{ __html: strings.ticketInfoPPMCPassL4 }} />
                            </ul>
                        </Row>
                    </Col>
                </Row>
            </Container>
        );
    }
}
